
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import AlerteForm from '@/components/forms/AlerteForm.vue'

const prospectModule = namespace('prospect')
const alerteModule = namespace('alerte')

@Component({
  components: {
    BaseCardContainer,
    AlerteForm
  }
})
export default class ProspectAlerteCreate extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @alerteModule.Action('createAlerteAction') createAlerte: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createAlerte(data).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectAlerte', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.replace({name: 'prospectAlerte', params: {id: this.$route.params.id}})
  }
}
